<template>
    <section class="category-stream stream">
        <div class="container" v-if="videoId">
            <div class="columns">
                <div class="column">
                    <div class="stream__player">
                        <transition name="fade" appear>
                            <Player :videoId="videoId" :isOutOfHours="isOutOfHours" :isTimeIsU="isTimeIsUp" :isTimeIsUpRemind="isTimeIsUpRemind" ></Player>
                        </transition>
                    </div>
                </div>
            </div>
        </div>

        <div class="stream__stations">
            <div class="container">
                <div class="columns">
                    <div v-for="(item, index) in stationList" class="column is-6-desktop is-12-mobile" :key="index">
                        <div class="stream__stations-item" :class="{'active' : item.code === activeStation.code, 'mini' : activeStation.code}" @click="setActiveStation(item)">
                            <figure>
                                <Image :image="item.image" :width="320" :height="0" :isLazy="false" v-if="item.image && item.code !== activeStation.code"></Image>
                                <Image :image="item.image_different" :width="320" :height="0" :isLazy="false" v-if="item.image_different && item.code === activeStation.code"></Image>
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <ModuleStationProgram v-if="activeStation.code" :stationCode="activeStation.code"></ModuleStationProgram>
        </div>

        <ModalTimeLimit 
            v-if="isModalTimeLimit && activeSubProfile && activeSubProfile._id" 
            :isTimeIsUp="isTimeIsUp"
            :isOutOfHours="isOutOfHours"
            :isTimeIsUpRemind="isTimeIsUpRemind"
            :activeSubProfile="activeSubProfile"
            @closeModalHandle="closeModalHandle"
            @stopRecordTime="stopRecordTime">
        </ModalTimeLimit>
    </section>
</template>

<script>
import axios from "axios";
import Image from "../elements/Image.vue";
import ModuleStationProgram from "../modules/ModuleStationProgram.vue";
import Player from "../elements/Player.vue";
import ModalTimeLimit from "../modals/ModalTimeLimit.vue";
import { recordTime } from '../../mixins/recordTime';
import { registerVisit } from '../../mixins/registerVisit';
import { checkIsOutOfHours } from '../../mixins/checkIsOutOfHours';
import globalDataLayer from '../../mixins/globalDataLayer';

export default {
    name: "CategoryStream",
    components: {
        Image,
        Player,
        ModuleStationProgram,
        ModalTimeLimit
    },
    mixins: [recordTime, registerVisit, globalDataLayer, checkIsOutOfHours],
    props: {
        pageId: {
            type: Number,
            required: true,
        },
        name: {
            type: String,
            required: true
        }
    },    
    data() {
        return {
            STATIONS: '/api/krainaabc/stations?device=www',
            stationList: [],
            activeStation: {},
            videoId: null,
            recordTimeIntervalId: null,
            checkHoursIntervalId: null,
            isModalTimeLimit: false
        };
    },
    watch: {
        '$route.path': {
            handler: function() {
                this.getStationList()
            },
            deep: true,
            immediate: true
        },
        activeSubProfile(value) {
            if(value && value._id && value.game_restriction !==0 && this.activeStation.code) {
                if(this.isTimeIsUp || (value.remaining_time === 0 && !value.play_from)) {
                    if(!this.value.play_from && !this.value.play_to) {
                        this.isModalTimeLimit = true;  
                        clearInterval(this.recordTimeIntervalId);
                        clearInterval(this.checkHoursIntervalId);
                        this.recordTimeIntervalId = null;
                        this.checkHoursIntervalId = null;    
                    }
                } else if(this.isOutOfHours) {
                    this.isModalTimeLimit = true;  
                    clearInterval(this.recordTimeIntervalId);
                    clearInterval(this.checkHoursIntervalId);
                    this.recordTimeIntervalId = null;
                    this.checkHoursIntervalId = null;  
                } else {
                    checkIsOutOfHours();
                    this.recordTimeIntervalId = recordTime(this.pageId);
                    this.checkHoursIntervalId = setInterval(checkIsOutOfHours, 60000);  
                }

                if(this.videoId) {
                    setTimeout(() => {
                        registerVisit(this.videoId, this.activeSubProfile._id)
                    }, 15000);
                }
            } else {
                if(this.recordTimeIntervalId) {
                    clearInterval(this.recordTimeIntervalId);
                    this.recordTimeIntervalId = null;
                }
                if(this.checkHoursIntervalId) {
                    clearInterval(this.checkHoursIntervalId)
                    this.checkHoursIntervalId = null;  
                }                
            }
        },  
        isModalTimeLimit(value) {
            if(value) {
                this.$store.dispatch("changeModalBackdrop", true);
                this.$store.dispatch("changeModalTimeLimitState", true);
            } else {
                this.$store.dispatch("changeModalBackdrop", false);
                this.$store.dispatch("changeModalTimeLimitState", false);
            }
        },
        isTimeIsUp(value) {
            if(this.activeSubProfile && this.activeSubProfile._id && this.activeStation.code) {
                if(value && !this.activeSubProfile.play_from && !this.activeSubProfile.play_to) {
                    this.isModalTimeLimit = true;  

                    clearInterval(this.recordTimeIntervalId);
                    this.recordTimeIntervalId = null; 

                    clearInterval(this.checkHoursIntervalId);
                    this.checkHoursIntervalId = null; 
                } else {
                    this.recordTimeIntervalId = recordTime(this.pageId);
                }
            }
        },
        isTimeIsUpRemind(value) {
            if(this.activeSubProfile && this.activeSubProfile._id && this.activeStation.code) {
                if(value && !this.activeSubProfile.play_from && !this.activeSubProfile.play_to) {
                    this.isModalTimeLimit = true;  
                }
            }
        },        
        isOutOfHours(value) {
            if(this.activeSubProfile && this.activeSubProfile._id && this.activeStation.code) {
                if(value) {
                    this.isModalTimeLimit = true;  

                    clearInterval(this.checkHoursIntervalId);
                    this.checkHoursIntervalId = null; 

                    clearInterval(this.recordTimeIntervalId);
                    this.recordTimeIntervalId = null; 
                } else {
                    this.checkHoursIntervalId = setInterval(checkIsOutOfHours, 60000);  
                    this.recordTimeIntervalId = recordTime(this.pageId);
                }
            }
        }      
    },
    computed: {
        activeSubProfile() {
            return this.$store.getters.getActiveSubProfile;
        },
        isTimeIsUp() {
            return this.$store.getters.isTimeIsUp;
        },
        isTimeIsUpRemind() {
            return this.$store.getters.isTimeIsUpRemind;
        },
        isOutOfHours() {
            return this.$store.getters.isOutOfHours;
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        }
    },
    methods: {
        getStationList() {
            axios.get(this.STATIONS).then((response) => {
                if (response.status === 200) {
                    if(response.data.data) {
                        this.stationList = response.data.data;
                    }
                }
            });
        },
        setActiveStation(item) {
            if(this.activeSubProfile && this.activeSubProfile._id) {
                if(this.isTimeIsUp || (this.activeSubProfile.remaining_time === 0 && !this.activeSubProfile.play_from)) {
                    if(!this.activeSubProfile.play_from && !this.activeSubProfile.play_to) {
                        this.isModalTimeLimit = true;  
                        clearInterval(this.recordTimeIntervalId);
                        clearInterval(this.checkHoursIntervalId);
                        this.recordTimeIntervalId = null;
                        this.checkHoursIntervalId = null;    
                    } else if(this.isOutOfHours) {
                        this.isModalTimeLimit = true;  
                        clearInterval(this.recordTimeIntervalId);
                        clearInterval(this.checkHoursIntervalId);
                        this.recordTimeIntervalId = null;
                        this.checkHoursIntervalId = null; 
                    }
                } else if(this.isOutOfHours) {
                    this.isModalTimeLimit = true;  
                    clearInterval(this.recordTimeIntervalId);
                    clearInterval(this.checkHoursIntervalId);
                    this.recordTimeIntervalId = null;
                    this.checkHoursIntervalId = null; 
                } else {
                    checkIsOutOfHours();

                    this.activeStation = {
                        code: item.code,
                        video_id: item.video_id,
                        cms_id: item.cms_id
                    }
                    this.videoId = item.video_id;
                    this.scrollTop();

                    if(this.pageId && !this.intervalId) {
                        this.recordTimeIntervalId = recordTime(this.pageId);
                        this.checkHoursIntervalId = setInterval(checkIsOutOfHours, 60000);  
                    }

                    setTimeout(() => {
                        registerVisit(item.cms_id, this.activeSubProfile._id)
                    }, 15000);  

                    this.checkIntervalId = setInterval(checkIsOutOfHours, 60000);  
                }
            } else {
                this.activeStation = {
                    code: item.code,
                    video_id: item.video_id,
                    cms_id: item.cms_id
                }
                this.videoId = item.video_id;      
                this.scrollTop();          
            }
            window.gemius_event(
                '_action_',
                this.gemiusIdentifier,
                `NAME=${item.code}`
            ); 
        },
        closeModalHandle() {
            this.isModalTimeLimit = false;
        },
        stopRecordTime() {
            clearInterval(this.recordTimeIntervalId);
            this.recordTimeIntervalId = null; 
        },        
        scrollTop() {
            setTimeout(function() {
                const videoTop = document.querySelector(
                    '.category-stream'
                );

                const startPos = window.pageYOffset;

                if (videoTop) {
                    const diff = videoTop.getBoundingClientRect().top;
                    
                    window.scrollTo({
                        top: startPos + diff - 100,
                        behavior: 'smooth'
                    });
                }
            }, 100);            
        }           
    },
    mounted() {
        this.navigationEvent(this.name);

        window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        ); 
    },
    unmounted() {
        this.$store.dispatch("setIsOutOfHours", false);  
        this.$store.dispatch("setIsTimeIsUp", false);
        this.$store.dispatch("changeModalBackdrop", false);
        this.$store.dispatch("changeModalTimeLimitState", false);
        clearInterval(this.recordTimeIntervalId);
        clearInterval(this.checkHoursIntervalId);
        this.recordTimeIntervalId = null;
        this.checkHoursIntervalId = null;  
    }         
}
</script>
